import React, { useMemo } from "react";
import {
  Button,
  Chip,
  Divider,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import LocationPicker from "./LocationPicker";
import { LOCATION_EDGE_TYPE_LABEL, isLocationEdgeType } from "../locationTypes";

export default function LocationsSection({
  selectedNode,
  edges,
  nodeById,
  onAddLocation,
  onUpdateEdgeProps,
  onRemoveEdge,
  onFocusNode,
}) {
  const locationEdges = useMemo(() => {
    if (!selectedNode) return [];
    return edges.filter((edge) => edge.from?.nodeId === selectedNode.id && isLocationEdgeType(edge.type));
  }, [selectedNode, edges]);

  if (!selectedNode) return null;

  return (
    <>
      <Divider />
      <Typography variant="subtitle2" fontWeight={700}>Locations</Typography>
      <LocationPicker onAdd={onAddLocation} />

      {locationEdges.length === 0 && (
        <Typography variant="caption" color="text.secondary">No locations linked.</Typography>
      )}

      <Stack spacing={1}>
        {locationEdges.map((edge) => {
          const placeNode = nodeById.get(edge.to?.nodeId);
          const placeLabel = placeNode?.label || placeNode?.props?.formattedAddress || edge.to?.nodeId;
          return (
            <Stack key={edge.id} spacing={0.8} sx={{ p: 1, border: "1px solid #e2e8f0", borderRadius: 1.5 }}>
              <Stack direction="row" spacing={1} alignItems="center" useFlexGap flexWrap="wrap">
                <Chip size="small" label={LOCATION_EDGE_TYPE_LABEL[edge.type] || edge.type} />
                <Button size="small" onClick={() => onFocusNode(edge.to?.nodeId)}>{placeLabel}</Button>
                <Button
                  size="small"
                  color="error"
                  onClick={() => void onRemoveEdge(edge.id)}
                >
                  Remove
                </Button>
              </Stack>
              <Stack direction="row" spacing={1}>
                <TextField
                  size="small"
                  type="date"
                  label="Valid from"
                  value={edge.props?.validFrom || ""}
                  onChange={(event) => onUpdateEdgeProps(edge.id, { validFrom: event.target.value })}
                  InputLabelProps={{ shrink: true }}
                  fullWidth
                />
                <TextField
                  size="small"
                  type="date"
                  label="Valid to"
                  value={edge.props?.validTo || ""}
                  onChange={(event) => onUpdateEdgeProps(edge.id, { validTo: event.target.value })}
                  InputLabelProps={{ shrink: true }}
                  fullWidth
                />
              </Stack>
              <TextField
                size="small"
                label="Notes"
                value={edge.props?.notes || ""}
                onChange={(event) => onUpdateEdgeProps(edge.id, { notes: event.target.value })}
              />
            </Stack>
          );
        })}
      </Stack>
    </>
  );
}
